
export default function InfoCard({ label, value, subtitle, logo, logoAlt, variant = "default", className = "", valueClassName = "" }) {
  const baseClasses = "bg-white rounded-lg border-2 p-4 shadow-sm"

  const variantClasses = {
    default: "border-gray-200 justify-between",
    center: "border-gray-200 text-center",
    technology: "border-blue-200",
    AlignJustify:"border-gray-300 justify-center"
  }

  return (
  <div className={`${baseClasses} ${variantClasses[variant]} ${className} flex items-center  w-full`}>
  <div>
    <div className="text-sm text-gray-600">{label}</div>
    <div className={`font-semibold text-[#2F4B7C] text-lg ${valueClassName}`}>
      {value}
      {subtitle && <span className="text-sm text-gray-500 ml-1">{subtitle}</span>}
    </div>
  </div>

  {logo && (
    <img
      src={logo || "/placeholder.svg"}
      alt={logoAlt || ""}
      className={logo.includes("wateraid") ? "h-14 w-20" : logo.includes("dphe_logo") ? "w-10 h-10 rounded-full" : logo.includes("wsup") || logo.includes("snv") ? " h-10 rounded-full" : "h-10 "}
    />
  )}
</div>
  )
}
